module.exports = __webpack_public_path__ + "static/img/wheel-bg.e43914ed.png";